<button class="primary button" [disabled]="disabled" (click)="patientCallStartEvent()">
  Start Follow-Up
</button>
